import { Link } from 'react-router-dom';
import { Button } from '@flixbus/honeycomb-react';
import { Icon, IconArrowLeft } from '@flixbus/honeycomb-icons-react';

import CopyVoucher from '../CopyVoucher/CopyVoucher';

import styles from './voucher-nav.module.scss';

const VoucherNav = () => {
  return (
    <div className={styles.container}>
      <Button Elem='a' appearance='link' RouterLink={Link} to='/'>
        <Icon InlineIcon={IconArrowLeft} />
        Back
      </Button>
      <CopyVoucher />
    </div>
  );
};

export default VoucherNav;
